import { defineComponent } from "vue";
import IconButton from "../common/base/IconButton.vue.mjs";
import ChatIcon from "../common/icons/ChatIcon.vue.mjs";
import { useBasicStore } from "../../stores/basic.mjs";
import { useChatStore } from "../../stores/chat.mjs";
import { storeToRefs } from "pinia";
import { useI18n } from "../../locales/index.mjs";
import TuiBadge from "../common/base/Badge.vue.mjs";
import "../../services/main.mjs";
import { roomService } from "../../services/roomService.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../utils/environment.mjs";
import "mitt";
import "../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
import { MetricsKey } from "../../services/manager/dataReportManager.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ChatControl",
  setup(__props) {
    const { t } = useI18n();
    const chatControlConfig = roomService.getComponentConfig("ChatControl");
    const basicStore = useBasicStore();
    const chatStore = useChatStore();
    const { sidebarName } = storeToRefs(basicStore);
    async function toggleChatSidebar() {
      if (basicStore.isSidebarOpen && basicStore.sidebarName === "chat") {
        basicStore.setSidebarOpenStatus(false);
        basicStore.setSidebarName("");
        return;
      }
      basicStore.setSidebarOpenStatus(true);
      basicStore.setSidebarName("chat");
      chatStore.updateUnReadCount(0);
      roomService.dataReportManager.reportCount(MetricsKey.openChat);
      roomService.trackingManager.sendMessage("experience-chat");
    }
    return { __sfc: true, t, chatControlConfig, basicStore, chatStore, sidebarName, toggleChatSidebar, IconButton, ChatIcon, TuiBadge };
  }
});
export {
  _sfc_main as default
};
